/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

import api from "@bmp-vue/core/api";

export default [
  {
    path: '/',
    view: 'Login',
    dir: 'views/',
    title: 'Login',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/auth/callback',
    view: 'AuthCallback',
    dir: 'views/',
    title: 'Autenticando',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    title: 'Dashboard',
    icon: 'fas fa-home',
    path: '/dashboard',
    view: 'Home',
    dir: 'views/',
    menu: true,
    meta: {
    }
  },
  {
    path: "/busca",
    view: "Busca",
    dir: "views/",
    title: "Busca",
    menu: false,
    meta: {
    }
  },
  {
    path: "/cliente",
    view: "Cliente",
    dir: "views/",
    title: "Cliente",
    menu: false,
    meta: {
    }
  }
];
